import { useExecOp } from 'Contexts/ExecOpContext';
import { getUserData } from 'queries/ossix/user/userData';
import React, { useEffect } from 'react';
import socketIOClient from './socketIO';

export const BULK_PAYMENT_EXECUTION_IN_PROGRESS =
  'BulkPaymentExecutionInProgress';
export const BULK_PAYMENT_EXECUTION_DONE = 'BulkPaymentExecutionDone';

interface ExecBulkPaymentSocketProps {
  onExInProgress?: (_message: string) => void;
  onExecutionDone?: (_response: any) => void;
}

const ExecBulkPaymentSocket: React.FC<ExecBulkPaymentSocketProps> = ({
  onExInProgress,
  onExecutionDone,
}) => {
  const { userData } = getUserData();
  const { setExecOpInProgress } = useExecOp();

  const data = userData?.[0];

  useEffect(() => {
    if (data?.PID) {
      socketIOClient.off(BULK_PAYMENT_EXECUTION_IN_PROGRESS);
      socketIOClient.on(
        BULK_PAYMENT_EXECUTION_IN_PROGRESS,
        (notification: { message: string }) => {
          const { message } = notification || {};
          if (onExInProgress) {
            onExInProgress(message);
          }
        },
      );
    }

    return () => {
      socketIOClient.off(BULK_PAYMENT_EXECUTION_IN_PROGRESS);
    };
  }, [data?.PID, onExInProgress]);

  useEffect(() => {
    if (data?.PID) {
      socketIOClient.off(BULK_PAYMENT_EXECUTION_DONE);
      socketIOClient.on(
        BULK_PAYMENT_EXECUTION_DONE,
        (executedData: any) => {
          if (onExecutionDone) {
            setExecOpInProgress(false);
            localStorage.removeItem('opExInProgress');
            onExecutionDone(executedData);
          }
        },
      );
    }

    return () => {
      socketIOClient.off(BULK_PAYMENT_EXECUTION_DONE);
    };
  }, [data?.PID, onExecutionDone]);

  return null;
};

export default ExecBulkPaymentSocket;
